import { createAction } from '@reduxjs/toolkit';

export const GET_UPLOADS = 'GET_UPLOADS';
export const GETTING_UPLOADS = 'GETTING_UPLOADS';
export const GETTING_UPLOADS_SUCCEEDED = 'GETTING_UPLOADS_SUCCEEDED';
export const GETTING_UPLOADS_FAILED = 'GETTING_UPLOADS_FAILED';

export const GET_USAGE_TYPE_TAGS = 'GET_USAGE_TYPE_TAGS';
export const GETTING_USAGE_TYPE_TAGS = 'GETTING_USAGE_TYPE_TAGS';
export const GETTING_USAGE_TYPE_TAGS_SUCCEEDED = 'GETTING_USAGE_TYPE_TAGS_SUCCEEDED';
export const GETTING_USAGE_TYPE_TAGS_FAILED = 'GETTING_USAGE_TYPE_TAGS_FAILED';

export const CREATE_UPLOAD = 'CREATE_UPLOAD';
export const CREATING_UPLOAD = 'CREATING_UPLOAD';
export const CREATING_UPLOAD_SUCCEEDED = 'CREATING_UPLOAD_SUCCEEDED';
export const CREATING_UPLOAD_FAILED = 'CREATING_UPLOAD_FAILED';

export const UPDATE_UPLOAD = 'UPDATE_UPLOAD';
export const UPDATING_UPLOAD = 'UPDATING_UPLOAD';
export const UPDATING_UPLOAD_SUCCEEDED = 'UPDATING_UPLOAD_SUCCEEDED';
export const UPDATING_UPLOAD_FAILED = 'UPDATING_UPLOAD_FAILED';

export const DELETE_UPLOAD = 'DELETE_UPLOAD';
export const DELETING_UPLOAD = 'DELETING_UPLOAD';
export const DELETING_UPLOAD_SUCCEEDED = 'DELETING_UPLOAD_SUCCEEDED';
export const DELETING_UPLOAD_FAILED = 'DELETING_UPLOAD_FAILED';

export const UPDATE_UPLOAD_FILTERS = 'UPDATE_UPLOAD_FILTERS';
export const RESET_UPLOAD_FILTERS = 'RESET_UPLOAD_FILTERS';
export const CLEAR_UPLOADS_ERROR = 'CLEAR_UPLOADS_ERROR';
export const CLEAR_UPLOADS_STORE = 'CLEAR_UPLOADS_STORE';

export const getUploads = createAction(GET_UPLOADS);
export const gettingUploads = createAction(GETTING_UPLOADS);
export const gettingUploadsSucceeded = createAction(GETTING_UPLOADS_SUCCEEDED);
export const gettingUploadsFailed = createAction(GETTING_UPLOADS_FAILED);

export const getUsageTypeTags = createAction(GET_USAGE_TYPE_TAGS);
export const gettingUsageTypeTags = createAction(GETTING_USAGE_TYPE_TAGS);
export const gettingUsageTypeTagsSucceeded = createAction(GETTING_USAGE_TYPE_TAGS_SUCCEEDED);
export const gettingUsageTypeTagsFailed = createAction(GETTING_USAGE_TYPE_TAGS_FAILED);

export const createUpload = createAction(CREATE_UPLOAD);
export const creatingUpload = createAction(CREATING_UPLOAD);
export const creatingUploadSucceeded = createAction(CREATING_UPLOAD_SUCCEEDED);
export const creatingUploadFailed = createAction(CREATING_UPLOAD_FAILED);

export const updateUpload = createAction(UPDATE_UPLOAD);
export const updatingUpload = createAction(UPDATING_UPLOAD);
export const updatingUploadSucceeded = createAction(UPDATING_UPLOAD_SUCCEEDED);
export const updatingUploadFailed = createAction(UPDATING_UPLOAD_FAILED);

export const deleteUpload = createAction(DELETE_UPLOAD);
export const deletingUpload = createAction(DELETING_UPLOAD);
export const deletingUploadSucceeded = createAction(DELETING_UPLOAD_SUCCEEDED);
export const deletingUploadFailed = createAction(DELETING_UPLOAD_FAILED);

export const updateUploadFilters = createAction(UPDATE_UPLOAD_FILTERS);
export const resetUploadFilters = createAction(RESET_UPLOAD_FILTERS);
export const clearUploadsError = createAction(CLEAR_UPLOADS_ERROR);
export const clearUploadsStore = createAction(CLEAR_UPLOADS_STORE);